import reducer from "./reducer";
export { default as accessSettings } from "./components/index";
export { default as accessSettingsReducerName } from "./constants";
export default reducer;
